import { Reveal, SectionLabel } from "./Reveal";
import { PRODUCTIONS } from "../data/content";

export const Produzioni = () => (
  <section
    id="produzioni"
    data-testid="productions-section"
    className="relative py-24 sm:py-32 bg-[#0c0a11] border-y border-[#282338]"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <SectionLabel>Dietro le Quinte</SectionLabel>
      </Reveal>
      <div className="mt-5 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <Reveal delay={0.1}>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl leading-tight">
            Produzioni{" "}
            <span className="italic text-gold-gradient">
              televisive, cinematografiche
            </span>{" "}
            e discografiche
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-base text-[#A19CAE] max-w-md leading-relaxed">
            Non solo palcoscenico: scriviamo, giriamo, registriamo e
            distribuiamo. Un unico partner creativo dall'idea alla messa in
            onda.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 lg:auto-rows-[17rem] gap-6">
        {PRODUCTIONS.map((p, i) => (
          <Reveal
            key={p.id}
            delay={i * 0.08}
            className={`col-span-1 md:col-span-2 lg:col-span-auto ${p.span}`}
          >
            <article
              data-testid={`production-card-${p.id}`}
              className="card-spotlight group relative h-full min-h-[17rem] rounded-2xl overflow-hidden border border-[#282338]"
            >
              <img
                src={p.image}
                alt={p.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-70 transition-all duration-700 ease-out group-hover:scale-105 group-hover:opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#08070B] via-[#08070B]/45 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-7">
                <span className="font-mono-label text-[10px] tracking-[0.3em] text-[#E6C594]">
                  {p.code}
                </span>
                <h3 className="font-serif-display text-2xl sm:text-3xl font-semibold mt-2">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-[#A19CAE] leading-relaxed max-w-lg">
                  {p.desc}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
